import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import type { RouterContext } from "../types";
import { SiteHeader } from "../components/site-header";
import { BottomTabBar } from "../components/bottom-tab-bar";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col pb-[calc(56px+env(safe-area-inset-bottom))] sm:pb-0">
      <SiteHeader />
      <Outlet />
      <BottomTabBar />
    </div>
  );
}
